import React, { useContext, useEffect, useState } from "react";
import JunctionImage from "../../../../images/ItemIcons/junction.svg";
import { useLazyQuery } from "@apollo/client";
import {
  GetTransformJunctionResult,
  GetTransformJunctionVar,
} from "../queries/types";
import { GetTransformJunction } from "../queries/queries";
import { AppContext } from "../../../../context/context";
const JunctionDetails = () => {
  const [junctionData, setJunctionData] = useState({
    name: "",
    alias: "",
    jType: "",
    arms: 0,
    icon: "",
    vendor: "",
    code: "",
  });
  const { state } = useContext(AppContext);

  const [getTransformJunction, { loading: getLoading, error }] = useLazyQuery<
    GetTransformJunctionResult,
    GetTransformJunctionVar
  >(GetTransformJunction);

  useEffect(() => {
    if (state.junctionID && state.customerId) {
      getTransformJunction({
        variables: {
          token: "",
          customerID: state.customerId,
          junctionID: state.junctionID,
        },
      }).then(({ data }) => {
        if (data && data.GetTransformJunction) {
          setJunctionData({
            name: data.GetTransformJunction.name,
            alias: data.GetTransformJunction.alias,
            jType: data.GetTransformJunction.jType,
            arms: data.GetTransformJunction.arms,
            icon: data.GetTransformJunction.icon,
            vendor: data.GetTransformJunction.vendorDetails.desc,
            code: data.GetTransformJunction.code,
          });
        }
      });
    }
  }, [getTransformJunction, state.junctionID, state.customerId]);

  return (
    <div className="mobile-raise-ticket__junctions">
      <div className="mobile-raise-ticket__junctions--h">
        <div
          className="mobile-raise-ticket__junctions--h--flex"
          //   className={`maps-item-details__asset--h--flex ${
          //     data.node.priority === PriorityEnum.CRITICAL
          //       ? "border-red"
          //       : data.node.priority === PriorityEnum.MEDIUM
          //       ? "border-yellow"
          //       : data.node.priority === PriorityEnum.LOW
          //       ? "border-green"
          //       : ""
          //   }

          //       `}
        >
          <img src={JunctionImage} alt="" />
          <div>
            <b className="mobile-raise-ticket__junctions--h--item">
              {junctionData.name}
            </b><br></br>
            <span> {junctionData.code}</span>

            <div className="mobile-raise-ticket__junctions--h--span d-flex gap-2">
              <span> {junctionData.alias} </span>
              <span> {junctionData.vendor}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JunctionDetails;
